import { connect } from 'react-redux'
import { navigationEvent } from 'layers/navigation/store/operations'
import ResourceCard from './component'

const mapDispatchToProps = {
  navigationEvent,
}

export default connect(null, mapDispatchToProps)(ResourceCard)
